import { h, render } from 'preact';

export default ({ children, ...props}) => {
    const path = props.path || [];

    return (
        <header
            className={`page-header ${props.backgroundSrc ? '_cover _autoscale' : ''}`}>
            <div
                className="wrapper page-header__outer-wrapper"
                style={{
                    backgroundImage: props.backgroundSrc ? `url(${props.backgroundSrc})`: 'none'
                }}>
                <div class="wrapper page-header__inner-wrapper">
                    <div class="page-header__wrapper">
                        <nav class="breadcrumbs page-header__breadcrumbs">
                            <a href="/" class="breadcrumbs__item">Главная</a>
                            {
                                path.map(([title, url, ...other]) => {
                                    if(url) {
                                        return (
                                            <a
                                                href={url}
                                                class="breadcrumbs__item">
                                                {title}
                                            </a>
                                        )
                                    }
                                    else {
                                        return (
                                            <span class="breadcrumbs__item">
                                                {title}
                                            </span>
                                        )
                                    }
                                })
                            }
                        </nav>

                        {
                            props.title
                                ?
                                    <h1
                                        class="page-header__title"
                                        style={props.titleStyle || {}}>
                                        {props.title}
                                    </h1>
                                : null
                        }

                        { children }
                    </div>
                </div>

                {
                    typeof(props.footer) === 'function'
                        ? props.footer()
                        : null
                }

            </div>
        </header>
    )
}